;(function ($) {
	'use strict';
	$(document).ready(function () {
		$(document).on('change', '.graphite-comparison-tool .option', function (e) {
			const companyUpdated = this.dataset.option === 'company';
			const materialUpdated = this.dataset.option === 'material';

			updateMaterials(companyUpdated);
			if(materialUpdated) {
				$('.compare-table-section').removeClass('hidden-section');
				getTable();
			}
		});

		$(document).on('change', '.electrode-selection-tool .option', function (e) {
			const workpieceUpdated = this.dataset.option === 'workpiece';
			const applicationUpdated = this.dataset.option === 'application';

			if(workpieceUpdated || applicationUpdated) {
				getElectrodes();
			}
		});

		$(document).on('click', '#comparison-tool', function (e) {
			$(this).toggleClass("toggled");
			$('#electrode-tool').removeClass("toggled");
			$('#graphite-comparison-tool').toggleClass("shown");
			$('#electrode-selection-tool').removeClass("shown");

			// move down to fields
			$('html').animate({
				scrollTop: $('.graphite-comparison-tool').offset().top - 140
			}, 800);
		});
		$(document).on('click', '#electrode-tool', function (e) {
			$(this).toggleClass("toggled");
			$('#comparison-tool').removeClass("toggled");
			$('#graphite-comparison-tool').removeClass("shown");
			$('#electrode-selection-tool').toggleClass("shown");

			// move down to fields
			$('html').animate({
				scrollTop: $('.electrode-selection-tool').offset().top - 140
			}, 800);
		});
		
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('tool') === '1') {
			$('#comparison-tool').toggleClass("toggled");
			$('#electrode-tool').removeClass("toggled");
			$('#graphite-comparison-tool').toggleClass("shown");
			$('#electrode-selection-tool').removeClass("shown");
		} else if (urlParams.get('tool') === '2') {
			$('#electrode-tool').toggleClass("toggled");
			$('#comparison-tool').removeClass("toggled");
			$('#graphite-comparison-tool').removeClass("shown");
			$('#electrode-selection-tool').toggleClass("shown");
		}

		$.post({
			url: '/api/electrode-selection-tool',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify({
				application: ['both'],
				workpiece: [1],
			}),
			success: (response) => {
				updateElectrodeWheelMaterials(response);
			},
			error: e => {
				handleError(e);
			}
		});

		$(document).on('click', '.workpiece', function() {
			const id = this.dataset.workpiece;
			const position = this.dataset.position;

			$('#electrode_selection_wheel .text-overlay').attr('data-position', position);

			$.post({
				url: '/api/electrode-selection-tool',
				dataType: 'json',
				contentType: 'application/json',
				data: JSON.stringify({
					application: ['both'],
					workpiece: [id],
				}),
				success: (response) => {
					updateElectrodeWheelMaterials(response);
				},
				error: e => {
					handleError(e);
				}
			});
		});

		$(document).on('click', '.flip-button', function () {
			$('.electrode-selection-wheel').toggleClass('flip');
		});
	});
})(jQuery, window, document);

function updateElectrodeWheelMaterials(materials) {
	const roughingValues = $('.roughing-values');

	roughingValues.css('opacity', '0');

	setTimeout(() => {
		roughingValues.html('');
		for (const material of materials.roughing) {
			roughingValues.append(material.material_title + '<br>');
		}
		roughingValues.css('opacity', '1');
	}, 1000)


	const finishingValues = $('.finishing-values');

	finishingValues.css('opacity', '0');

	setTimeout(() => {
		finishingValues.html('');
		for (const material of materials.finishing) {
			finishingValues.append(material.material_title + '<br>');
		}

		finishingValues.css('opacity', '1');
	}, 1000);
}

function updateMaterials(companyUpdated = false) {
	const focusedElement = document.activeElement;

	let form = $('#graphite_comparison_form').serializeArray()

	if (companyUpdated) {
		form = {
			company: [form[0]['value']]
		}
		$.post({
			url: '/api/company-materials',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(
				form
			),
			success: (response) => {

				// update options
				updateFields(response.company_materials);
			},
			error: e => {
				handleError(e);
			}
		});
	}


}

function updateFields(company_materials) {
	const optionContainer = $('#materials_div');

	const previousOptions = $('#materials_div .option');

	let fields = [];
	fields.push(getOptionField(company_materials));
	optionContainer.html(fields)
}

function getOptionField(materials) {
	const field = document.createElement('select');
	field.dataset.option = 'material';


	Object.assign(field, {
		name: 'material',
		className: 'option',
	});

	const defaultOption = document.createElement('option');

	defaultOption.text = 'Select Material';
	defaultOption.value = '';

	field.appendChild(defaultOption);

	for (const company_material of materials) {
		let optionElement = document.createElement('option');

		optionElement.text = company_material['company_material_material'];
		optionElement.value = company_material['company_material_id'];

		field.appendChild(optionElement);
	}

	return field;
}

function getTable() {
	const tableContainer = $('#table_div');
	let form = $('#graphite_comparison_form').serializeArray()

	form = {
		company: [form[0]['value']],
		material: [form[1]['value']]
	}
	$.post({
		url: '/api/company-materials/get-comparison',
		dataType: 'json',
		contentType: 'application/json',
		data: JSON.stringify(
			form
		),
		success: (response) => {
			tableContainer.html(response);
		},
		error: e => {
			handleError(e);
		}
	});
}

function getElectrodes() {
	const electrodesContainer = $('#electrodes_div');
	let form = $('#electrode_selection_form').serializeArray()
	electrodesContainer.html('');
	form = {
		workpiece: [form[0]['value']],
		application: [form[1]['value']]
	}
	$.post({
		url: '/api/electrode-selection-tool',
		dataType: 'json',
		contentType: 'application/json',
		data: JSON.stringify(
			form
		),
		success: (response) => {
			if(response) {
				for (const material of response) {
					electrodesContainer.append('<p style="padding: 15px;">' + material.material_title + '</p>')
				}
			}
		},
		error: e => {
			handleError(e);
		}
	});
}